const SendLead = () => {
    return <><h1>Send Lead</h1></>
}

export default SendLead;